import { QueryClient } from 'react-query'
import { invalidateVrLicenseQueries } from '../../value-reporting/modules/licenses/api/queries/vr-licenses'

// Call refresh and invalidate VR dashboard license data queries
export function refreshAndInvalidateVrLicenseQueries({
  queryClient,
  refresh
}: {
  queryClient: QueryClient
  refresh: () => Promise<any>
}) {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  invalidateVrLicenseQueries(queryClient)
  return refresh()
}
